import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StatementOfAccountRunLineModel } from "../../../../../../models/aggregates/erp/statement-of-account/statement-of-account-run-line.model";
import { ApiResponseModel, ApiVisa } from '../../shared';

@Injectable({ providedIn: "root" })
export class StatementOfAccountRunLineService extends BaseApiTemplateService<StatementOfAccountRunLineModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
    "lines/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
      "lines/backoffice-ep";
    this.httpClient = theHttp;
  }

  printPdf(guid: string, apiVisa: ApiVisa) {
    let url =  Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.STATEMENT_OF_ACCOUNT_PREFIX;
    let ep = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +  "lines/" + "print/" + "backoffice-ep/";
    if (ep && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + ep;
    }
    return this.httpClient.get<Blob>(
      url + guid,
      this.getHttpHeaderBlob(apiVisa)
    )
  }

  sendEmail(guid: string, apiVisa: ApiVisa) {
    let url =  Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.STATEMENT_OF_ACCOUNT_PREFIX;
    let ep = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +  "lines/" + "email/" + "backoffice-ep/";
    if (ep && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + ep;
    }
    return this.httpClient.post(
     url + guid, null, this.getHttpHeader(apiVisa))
  }
}
